module.exports = __webpack_public_path__ + "static/media/ahnuld_hq.524bcfb5.gif";